import { Spin } from "../ui/Spin";
import { theme } from "../ui/theme";
import type { ReactNode } from "react";
import { spacing } from "../settings/settingsListDesign";
import "./LoadingOverlay.css";
import { useBackgroundRefreshBlocker } from "../system/useBackgroundRefresh";

export type LoadingOverlayScope = "block" | "screen" | "placeholder";
export interface LoadingOverlayProps {
  visible: boolean; scope?: LoadingOverlayScope; message?: ReactNode; loadingLabel?: string;
  screenTopInset?: string; children?: ReactNode;
}

/** Complete member loading behavior; translated text and optional desktop/banner inset come from adapters. */
export function LoadingOverlay({ visible, scope = "block", message, loadingLabel, screenTopInset = "0px", children }: LoadingOverlayProps) {
  useBackgroundRefreshBlocker(visible && scope === "screen");
  const { token } = theme.useToken();
  const indicator = <div role="status" aria-label={loadingLabel} aria-busy="true" aria-live="polite" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: spacing.md }}>
    <Spin size="large" />{message ? <span style={{ fontSize: token.fontSize, color: token.colorTextSecondary }}>{message}</span> : null}
  </div>;
  if (scope === "placeholder") return visible ? <div className="mu-loading-placeholder">{indicator}</div> : <>{children}</>;
  if (scope === "screen") return <>{children}{visible && <div className="mu-loading-screen" style={{ inset: `${screenTopInset} 0 0`, background: token.colorBgMask, zIndex: token.zIndexPopupBase + 100 }}>{indicator}</div>}</>;
  return <div className="mu-loading-host" aria-busy={visible || undefined} data-empty={visible && children == null || undefined}><div className="mu-loading-dim" data-busy={visible ? "true" : "false"} inert={visible || undefined}>{children}</div><div className="mu-loading-indicator" data-busy={visible ? "true" : "false"} aria-hidden={!visible}>{visible ? indicator : null}</div></div>;
}
